var map = {
	"./arrow-head.svg": 8165,
	"./arrow-left.svg": 635,
	"./arrow-top.svg": 9426,
	"./economic.svg": 3998,
	"./environment.svg": 2858,
	"./governance.svg": 6496,
	"./social.svg": 5097
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3287;